/**
 * /ai/codex —— MCP 营销落地页（Codex）。
 * 页面主体复用共享组件 McpLanding，本文件用 cdnHost 构造平台数据（./constants getConstants）+ SEO 数据（./fetch）。
 * cdnHost 来自 fetch 注入的 pageData（CSR 兜底取全局 CDN_HOST），图片走 ${cdnHost}/resources/egg/ai/codex/。
 */
import React, { useMemo } from 'react';
import withSSR from '../../hoc/withSSR';
import McpLanding from '../mcpLanding/McpLanding';
import fetchData from './fetch';
import { getConstants } from './constants';

function CodexPage(props) {
  const pageData = props.pageData || {};
  const cdnHost = pageData.cdnHost || (typeof CDN_HOST !== 'undefined' ? CDN_HOST : '');
  const data = useMemo(function () {
    return getConstants(cdnHost);
  }, [cdnHost]);
  return <McpLanding data={data} moduleName="codex" />;
}

CodexPage.fetch = fetchData;

export default withSSR(CodexPage);
